import {
  GET_SURVEYS_PENDING,
  GET_SURVEYS_SUCCESS,
  GET_SURVEYS_FAIL,
  SURVEYS_ANSWERS_PENDING,
  SURVEYS_ANSWERS_SUCCESS,
  SURVEYS_ANSWERS_FAIL,
  GET_SURVEYS_RESULT_PENDING,
  GET_SURVEYS_RESULT_SUCCESS,
  GET_SURVEYS_RESULT_FAIL,
  SET_CURRENT_QUESTION_NUMBER,
  SET_SHOW_SURVEY_VERIFICATION,
  SET_SHOW_SURVEY_RESULTS,
  SET_SHOW_SURVEY,
} from "./mutation-types";

export default {
  // Survey data mutations
  [GET_SURVEYS_PENDING](state) {
    state.isLoading.getSurveys = true;
    state.errors.getSurveys = null;
    // Backward compatibility
    state.isGetSurveyPending = true;
    state.errorOfGetSurveyFail = null;
  },

  [GET_SURVEYS_SUCCESS](state, payload) {
    state.isLoading.getSurveys = false;
    state.survey = payload;
    state.errors.getSurveys = null;
    // Backward compatibility
    state.isGetSurveyPending = false;
  },

  [GET_SURVEYS_FAIL](state, error) {
    state.isLoading.getSurveys = false;
    state.errors.getSurveys = error;
    // Backward compatibility
    state.isGetSurveyPending = false;
    state.errorOfGetSurveyFail = error;
  },

  // Survey answers mutations
  [SURVEYS_ANSWERS_PENDING](state) {
    state.isLoading.surveyAnswers = true;
    state.errors.surveyAnswers = null;
  },

  [SURVEYS_ANSWERS_SUCCESS](state) {
    state.isLoading.surveyAnswers = false;
    state.errors.surveyAnswers = null;
  },

  [SURVEYS_ANSWERS_FAIL](state, error) {
    state.isLoading.surveyAnswers = false;
    state.errors.surveyAnswers = error;
  },

  // Survey results mutations
  [GET_SURVEYS_RESULT_PENDING](state) {
    state.isLoading.surveyResults = true;
    state.errors.surveyResults = null;
  },

  [GET_SURVEYS_RESULT_SUCCESS](state, payload) {
    state.isLoading.surveyResults = false;
    state.surveyResult = payload;
    state.errors.surveyResults = null;
  },

  [GET_SURVEYS_RESULT_FAIL](state, error) {
    state.isLoading.surveyResults = false;
    state.errors.surveyResults = error;
  },

  // Survey state mutations
  [SET_CURRENT_QUESTION_NUMBER](state, number) {
    state.currentQuestionNumber = number;
  },

  [SET_SHOW_SURVEY_VERIFICATION](state, show) {
    state.showSurveyVerification = show;
  },

  [SET_SHOW_SURVEY_RESULTS](state, show) {
    state.showSurveyResults = show;
  },

  [SET_SHOW_SURVEY](state, show) {
    state.showSurvey = show;
  },
};
